import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { authApiService } from '../../authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getRecipientSourceWirePaymentDetailsApi = (
  wireId: string
): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/recipient/wires/${wireId}/source-wire/payment-details/`;

  return authApiService.GET(uri);
};
